import { orderSlice } from '../../../Slice/Order/OrderSlice.js'
import type { Epic } from 'Flux/index.js'
import { filter, map, mergeMap, of } from 'rxjs'
import { catchError } from 'rxjs/operators'
import { authenticationExpiredOr } from '../../../../Framework/Epic/AuthenticationExpired.js'
import { handleBatchUpdateSamples } from '../../Common/handleBatchUpdateSamples.js'
import { addMessage } from '../../../Slice/Application/ApplicationSlice.js'
import { errorMessage } from '../../../../Model/Message/IMessage.js'

export const BATCH_UPDATE_FAILURE_MESSAGE =
  'Saving the sample data failed. The order was reloaded so the table shows what was actually saved; check it before retrying.'

export const BatchUpdateSamplesEpic: Epic = (action$, state$, { [orderSlice.name]: order, OrderRepository }) =>
  action$.pipe(
    filter(order.batchUpdateSamples.match),
    mergeMap((action) =>
      handleBatchUpdateSamples(action.payload, OrderRepository).pipe(
        map(({ newMetadata, updatedMetadata, samples, batch }) =>
          order.batchUpdateSamplesSuccess({
            batch,
            result: { newMetadata, updatedMetadata, samples },
          })
        ),
        catchError((error) =>
          authenticationExpiredOr({
            error,
            failedRequest: action.type,
            /*
             * The batch is several requests in sequence, so a late failure leaves the earlier ones
             * committed. Without a reload the store never learns of them, and the next import creates
             * that metadata a second time.
             */
            failureAction: of(
              order.batchUpdateSampleFailure(error),
              addMessage(errorMessage(BATCH_UPDATE_FAILURE_MESSAGE)),
              order.getSampleMetaDatasRequest({ orderId: action.payload.orderId }),
              order.getAllDatasetRequest({ orderId: action.payload.orderId })
            )
          })
        )
      )
    )
  )
